import * as Types from "@clockwise/schema";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type ChromeNavEventQueryVariables = Types.Exact<{
  orgRelayId: Types.Scalars["ID"];
  calendarId: Types.Scalars["String"];
  externalEventId: Types.Scalars["String"];
}>;

export type ChromeNavEventQuery = {
  __typename: "Query";
  org:
    | { __typename: "Viewer"; id: string }
    | { __typename: "AggregateCalendarStats"; id: string }
    | { __typename: "FocusTimeMeetingDistribution"; id: string }
    | { __typename: "NonUserDefragEmailResponse"; id: string }
    | { __typename: "OrgPerson"; id: string }
    | { __typename: "Person"; id: string }
    | { __typename: "Room"; id: string }
    | { __typename: "TimeRangeNonNull"; id: string }
    | { __typename: "Sudo"; id: string }
    | { __typename: "CliCommand"; id: string }
    | { __typename: "PaymentSubscription"; id: string }
    | { __typename: "Urn"; id: string }
    | { __typename: "User"; id: string }
    | { __typename: "Flags"; id: string }
    | { __typename: "DataSource"; id: string }
    | { __typename: "FlowState"; id: string }
    | { __typename: "FlowStatus"; id: string }
    | {
        __typename: "Org";
        experiments: Array<string | null> | null;
        id: string;
        canScheduleResponse:
          | {
              __typename: "CanScheduleResponseList";
              list: Array<{
                __typename: "CanScheduleResponse";
                externalEventId: string;
                canReschedule: boolean;
              }>;
            }
          | { __typename: "GraphEntityError"; statusCode: number | null }
          | null;
        forceFetchEventParentErrorable:
          | {
              __typename: "EventParent";
              id: string;
              events: Array<{
                __typename: "Event";
                calendarIds: Array<string>;
                locked: boolean | null;
              }>;
            }
          | { __typename: "GraphEntityError"; statusCode: number | null };
      }
    | { __typename: "AsanaAccount"; id: string }
    | { __typename: "AnnotatedEvent"; id: string }
    | { __typename: "EventKey"; id: string }
    | { __typename: "CalendarStatus"; id: string }
    | { __typename: "TimeRange"; id: string }
    | { __typename: "CrawledCalendarInfo"; id: string }
    | { __typename: "EventColoringSettings"; id: string }
    | { __typename: "EventParentBase"; id: string }
    | { __typename: "EventParent"; id: string }
    | { __typename: "EventParentWrapper"; id: string }
    | { __typename: "ExternalGroup"; id: string }
    | { __typename: "FeedSuggestion"; id: string }
    | { __typename: "RewindHistory"; id: string }
    | { __typename: "CalendarMeetingHours"; id: string }
    | { __typename: "WorkingHours"; id: string }
    | { __typename: "OrgMeetingHours"; id: string }
    | { __typename: "UserMeetingHours"; id: string }
    | { __typename: "OrgInvite"; id: string }
    | { __typename: "Team"; id: string }
    | { __typename: "TeamSettings"; id: string }
    | { __typename: "TeamUserSettings"; id: string }
    | { __typename: "Setting"; id: string }
    | { __typename: "SettingKey"; id: string }
    | { __typename: "SettingType"; id: string }
    | { __typename: "ShadowCalendarSettings"; id: string }
    | { __typename: "SlackAccount"; id: string }
    | { __typename: "SlackSettings"; id: string }
    | { __typename: "SmartHoldEventInfo"; id: string }
    | { __typename: "EventMoveSuggestion"; id: string }
    | { __typename: "SuggestedOrgInvite"; id: string }
    | { __typename: "SuggestedRoomPreferences"; id: string }
    | { __typename: "UserDefinedTeam"; id: string }
    | { __typename: "UserSurveyResponseWrapper"; id: string }
    | { __typename: "UserWorkingHours"; id: string }
    | { __typename: "WorkingGroup"; id: string }
    | { __typename: "Calendar"; id: string }
    | { __typename: "CalendarWeek"; id: string }
    | { __typename: "DefragSuggestions"; id: string }
    | { __typename: "EventsQuery"; id: string }
    | { __typename: "ZoomAccount"; id: string }
    | null;
};

export const ChromeNavEventDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ChromeNavEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "orgRelayId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "calendarId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "externalEventId" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            alias: { kind: "Name", value: "org" },
            name: { kind: "Name", value: "node" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: { kind: "Variable", name: { kind: "Name", value: "orgRelayId" } },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "__typename" } },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "InlineFragment",
                  typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Org" } },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "experiments" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canScheduleResponse" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "calendarIds" },
                            value: {
                              kind: "ListValue",
                              values: [
                                { kind: "Variable", name: { kind: "Name", value: "calendarId" } },
                              ],
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "externalEventIds" },
                            value: {
                              kind: "ListValue",
                              values: [
                                {
                                  kind: "Variable",
                                  name: { kind: "Name", value: "externalEventId" },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "GraphEntityError" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "statusCode" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "CanScheduleResponseList" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "list" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "externalEventId" },
                                        },
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "canReschedule" },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "forceFetchEventParentErrorable" },
                        arguments: [
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "calendarId" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "calendarId" },
                            },
                          },
                          {
                            kind: "Argument",
                            name: { kind: "Name", value: "externalEventId" },
                            value: {
                              kind: "Variable",
                              name: { kind: "Name", value: "externalEventId" },
                            },
                          },
                        ],
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "__typename" } },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "GraphEntityError" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "statusCode" } },
                                ],
                              },
                            },
                            {
                              kind: "InlineFragment",
                              typeCondition: {
                                kind: "NamedType",
                                name: { kind: "Name", value: "EventParent" },
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "id" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "events" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "calendarIds" },
                                        },
                                        { kind: "Field", name: { kind: "Name", value: "locked" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<ChromeNavEventQuery, ChromeNavEventQueryVariables>;
